import { render, staticRenderFns } from "./switchTab.vue?vue&type=template&id=5393bbd6&scoped=true"
import script from "./switchTab.vue?vue&type=script&lang=js"
export * from "./switchTab.vue?vue&type=script&lang=js"
import style0 from "./switchTab.vue?vue&type=style&index=0&id=5393bbd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393bbd6",
  null
  
)

export default component.exports